import { HeadCell } from 'models/TableProps';
import {
    MyQuotationsHeadCellContent,
    QuotationsHeadCellContent,
} from '../../../models/quotations/Quotations';

export const QUOTATION_HEAD_CELLS: HeadCell<QuotationsHeadCellContent>[] = [
    {
        id: 'id',
        numeric: false,
        disablePadding: false,
        label: 'QUOTE_ID',
        sortable: true,
    },
    {
        id: 'name',
        numeric: false,
        disablePadding: false,
        label: 'QUOTATION_NAME',
        sortable: true,
    },
    {
        id: 'buyer',
        numeric: false,
        disablePadding: false,
        label: 'CUSTOMER_NAME',
        sortable: true,
    },
    // {
    //     id: 'count',
    //     numeric: false,
    //     disablePadding: false,
    //     label: 'COUNT',
    //     sortable: true,
    // },
    {
        id: 'created_at',
        numeric: false,
        disablePadding: false,
        label: 'ORDER_DATE',
        sortable: true,
    },
    {
        id: 'actions',
        numeric: false,
        disablePadding: false,
        label: 'ACTIONS',
        sortable: false,
    },
    {
        id: 'more',
        numeric: false,
        disablePadding: false,
        label: 'MORE',
        sortable: false,
    },
];

export const MY_QUOTATION_HEAD_CELLS: HeadCell<MyQuotationsHeadCellContent>[] =
    [
        {
            id: 'quoteNo',
            numeric: false,
            disablePadding: false,
            label: 'QUOTE_ID',
            sortable: true,
        },
        // {
        //     id: 'quotationName',
        //     numeric: false,
        //     disablePadding: true,
        //     label: 'QUOTATION_NAME',
        //     sortable: true,
        // },
        {
            id: 'orderDate',
            numeric: false,
            disablePadding: false,
            label: 'ORDER_DATE',
            sortable: true,
        },
        {
            id: 'status',
            numeric: false,
            disablePadding: false,
            label: 'STATUS',
            sortable: true,
        },
        {
            id: 'more',
            numeric: false,
            disablePadding: false,
            label: 'MORE',
            sortable: false,
        },
    ];
